"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridContext = void 0;
exports.default = Grid;
var React = _interopRequireWildcard(require("react"));
var _overrides = require("../helpers/overrides");
var _constants = require("./constants");
var _styledComponents = require("./styled-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
const GridContext = exports.GridContext = /*#__PURE__*/React.createContext({});
function Grid({
  align,
  behavior,
  children,
  gridColumns,
  gridGaps,
  gridGutters,
  gridMargins,
  gridMaxWidth,
  gridStyle = _constants.STYLE.default,
  gridUnit,
  overrides = {}
}) {
  const [StyledGrid, overrideProps] = (0, _overrides.getOverrides)(overrides.Grid, _styledComponents.StyledGrid);
  const [StyledGridWrapper, wrapperProps] = (0, _overrides.getOverrides)(overrides.GridWrapper, _styledComponents.StyledGridWrapper);
  const presetStyleValues = _constants.STYLE_VALUES[gridStyle];
  const gridStyleValues = presetStyleValues ? {
    $gridGutters: presetStyleValues.gutters,
    $gridMargins: presetStyleValues.margins,
    $gridMaxWidth: presetStyleValues.maxWidth,
    $gridUnit: presetStyleValues.unit
  } : {};
  const gridContextStyleValues = presetStyleValues && {
    gridColumns: presetStyleValues.columns,
    gridGaps: presetStyleValues.gaps,
    gridGutters: presetStyleValues.gutters,
    gridUnit: presetStyleValues.unit
  };
  return /*#__PURE__*/React.createElement(StyledGridWrapper, _extends({
    $behavior: behavior,
    $gridMargins: gridMargins != null ? gridMargins : gridStyleValues.$gridMargins,
    $gridMaxWidth: gridMaxWidth != null ? gridMaxWidth : gridStyleValues.$gridMaxWidth,
    $gridUnit: gridUnit != null ? gridUnit : gridStyleValues.$gridUnit
  }, wrapperProps), /*#__PURE__*/React.createElement(StyledGrid, _extends({
    $align: align,
    $behavior: behavior,
    $gridGutters: gridGutters != null ? gridGutters : gridStyleValues.$gridGutters,
    $gridMargins: gridMargins != null ? gridMargins : gridStyleValues.$gridMargins,
    $gridMaxWidth: gridMaxWidth != null ? gridMaxWidth : gridStyleValues.$gridMaxWidth,
    $gridUnit: gridUnit != null ? gridUnit : gridStyleValues.$gridUnit
  }, overrideProps), /*#__PURE__*/React.createElement(GridContext.Provider, {
    value: {
      gridColumns,
      gridGaps,
      gridGutters,
      // @ts-ignore
      gridUnit,
      ...gridContextStyleValues
    }
  }, children)));
}